<template>
  <div>
    <!-- 退换货办理 -->
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'returnExchangeChief' }">
          合同列表
        </el-breadcrumb-item>
        <el-breadcrumb-item>换货合同</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <baseInfoChange
      v-if="this.$route.query.rcontractType !=='虚拟换货合同'"
      ref="baseInfoChange"
      :info="from"
      @changeRebateCount="changeRebateCount"
    />

    <baseInfoChangeV v-if="this.$route.query.rcontractType ==='虚拟换货合同'" ref="baseInfoChangeV" :info="from" />

    <history ref="history" :approve-log-list="approveLogList" />
    <productChange ref="productList" :product-list="productList" :contract-id="from.contractId" :rebate-amount="from.rebateAmount" :rebate="from.rCashRebate" :sales-type="from.rSalesSettlementModes" @chooseAddress="chooseAddress" @changeAddress="changeAddress" @finalNet="finalNetSale" @orderSale="orderSale">
      <!-- <freight-info v-if="isShowFreightInfo" slot="freightInfo" ref="freightInfo" :form="info" :contract-num="info.contractNum" :receipt-address-id="info.receiptAddressId" @reChange="reChange" @getFreight="getFreight" /> -->
    </productChange>
    <el-button type="primary" :loading="submitLoading" @click="submit">
      保存并前往盖章
    </el-button>
  </div>
</template>

<script>
import baseInfoChange from './baseInfoChange.vue';
import baseInfoChangeV from './baseInfoChangeV.vue';
import history from './history.vue';
import productChange from './productChange.vue';
// import freightInfo from './freightInfo.vue';
import { getApproveData, submitToSignC } from '@/API';
import { numAdd, Subtr, MathMulti, numDiv } from '@/libs/util';

export default {
  data () {
    return {
      submitLoading: false,
      info: {
        contractType: '',
        departmentCode: '',
        id: 123,
        rebateAmount: 0,
        rebate: 0,
        salesType: '0',
        contractNum: '',
        receiptAddressId: ''
      },
      from: {},
      productList: [],
      freight: 0,
      finalNetSales: 0,
      orderSales: 0,
      adressId: '',
      approveLogList: [],
      productData: []
    };
  },
  components: {
    baseInfoChange,
    baseInfoChangeV,
    history,
    productChange
    // freightInfo
  },

  methods: {
    /*
    * @des 返利金额变更调整实际结算金额
    * 实际结算金额 = (原实际结算单价 * 数量) - (产品单价*扣点*数量/净销售额) * 返利金额)
    * 实际结算金额(最后一个) = (原实际结算单价 * 数量) - (返利金额 - ∑(产品单价*扣点*数量/净销售额*返利金额))
    */
    changeRebateCount (val) {
      let array = this.productList[0].addressList[0].contractProductList;

      // 原实际结算单价 * 数量
      let oldCount = (params) => {
        return MathMulti(params.roldProductActualPrice, params.rproductNum);
      };

      // (产品单价*扣点)*数量/净销售额
      let muitiFn = (params) => {
        if (this.from.rnetSales === 0) return 0;
        let count = numDiv(MathMulti(MathMulti(params.rproductPrice, this.from.rcashRebate), params.rproductNum), this.from.rnetSales);
        return Number(count.toFixed(2));
      };

      array.forEach((item, index) => {
        if (index !== array.length - 1) {
          item.rproductActualPriceAdd = Subtr(oldCount(item), MathMulti(muitiFn(item), val));
        } else {
          let count = array.slice(0, array.length - 1).reduce((pre, cur) => numAdd(pre, MathMulti(muitiFn(cur), val)), 0);
          item.rproductActualPriceAdd = Subtr(oldCount(item), Subtr(val, count));
        }
      });
    },

    async submit () {
      let baseInfo = {};
      if (this.$route.query.rcontractType === '虚拟换货合同') {
        baseInfo = this.$refs.baseInfoChangeV.info;
      } else {
        baseInfo = this.$refs.baseInfoChange.info;
      }

      try {
        await this.$refs.productList.validate();
      } catch (error) {
        return;
      }

      let parmas = {
        baseInfoModelVO: baseInfo,
        approveLogList: this.$refs.history.approveLogList,
        addressMOdelVOS: this.$refs.productList.rejectedList
      };

      this.submitLoading = true;
      submitToSignC(parmas)
        .then((res) => {
          let { status } = res.data;
          if (status === '200') {
            this.$router.push({ 'name': 'chiefReturnbFile', query: { contractId: this.$route.query.rcontractId } });
          } else {
            this.submitLoading = false;
          }
        }).catch(() => {
          this.submitLoading = false;
        });
    },

    initData () {
      getApproveData(this.$route.query.rcontractId, this.$route.query.rcontractType).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.from = json.data.baseInfoModelVO;
          this.approveLogList = json.data.approveLogList;
          this.productList = json.data.addressMOdelVOS;
        }
      });
    },
    // 初始化地址和切换地址成功触发
    chooseAddress (val) {
      this.adressId = val.id;
      this.info.receiptAddressId = val.id;
    },
    changeAddress () {
      // 判断是否是其他系统过来的单子，如果是，则不计算运费和显示
      // if (this.isShowFreightInfo) {
      // 重置运费信息
      // this.$refs.freightInfo.reset();
      // }
    },
    // 监听子组件运费模块中获取运费事件，并把值传给子组件产品列表
    getFreight (data) {
      this.freight = data;
    },
    finalNetSale (val) {
      this.finalNetSales = val;
    },
    orderSale (val) {
      this.orderSales = val;
    },
    reChange (data) {
      // 查询运费行，获取下标
      let index = this.productList.findIndex(function (v) {
        return v.productName === '价外费用-运费';
      });
      if (data.flag === 1) {
        // 判断产品列表里面是否有运费，如果有则不添加
        if (index === -1) {
          this.productList.push(data.product);
        }
      } else {
        if (index !== -1) {
          this.productList.splice(index, 1);
        }
      }
    }
  },
  mounted () {
    this.initData();
  },
  computed: {
    // 判断是否是其他系统过来的单子，如果是，则不计算运费和显示
    isShowFreightInfo () {
      if (this.info.contractType === '服务商分销下单' || this.info.contractType === 'SMB分销下单') {
        return false;
      }
      return true;
    }
  }
};
</script>
